import { RouteConfig } from 'vue-router';

import store from '@/store/store';
import { tryParseInt } from '@/utils/number';
import Settings from '@/views/setting/Tabs.vue';

export const settingsRoute: RouteConfig = {
  path: '',
  component: Settings,
  name: 'settings',
  meta: {
    breadcrumb: {
      title: 'breadcrumbs.settings.edit'
    }
  },
  beforeEnter: (to, from, next) => {
    store.commit('setting/group/setId', tryParseInt(to.params.groupId));
    store
      .dispatch('setting/group/list', { count: -1 })
      .then(() => next())
      .catch(() => store.dispatch('notifyError', { title: 'messages.setting.group.listError' }));
  }
};
